import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ScrollToTopRoute from './ScrollToTopRoute';
import Loadable from 'react-loadable';
import Loading from './components/helpers/Loading/Loading';

//stylesheets
import './components/views/AppHome/stylesheets/App.css';
import './components/views/Birth/stylesheets/Birth.css';
import './components/views/Cities/stylesheets/Cities.css';
import './components/views/Healthcare/stylesheets/Healthcare.css';
import './components/views/Housing/stylesheets/Housing.css';
import './components/views/Tax/stylesheets/Tax.css';

const Home = Loadable({
  loader: () => import('./components/views/AppHome/App'),
  loading: Loading
});
const Birth = Loadable({
  loader: () => import('./components/views/Birth/Birth'),
  loading: Loading
});
const Cities = Loadable({
  loader: () => import('./components/views/Cities/App'),
  loading: Loading
});
const Healthcare = Loadable({
  loader: () => import('./components/views/Healthcare/Healthcare'),
  loading: Loading
});
const Housing = Loadable({
  loader: () => import('./components/views/Housing/Housing'),
  loading: Loading
});
const Tax = Loadable({
  loader: () => import('./components/views/Tax/Tax'),
  loading: Loading
});
const NotFound = Loadable({
  loader: () => import('./components/views/NotFound/NotFound'),
  loading: Loading
});

// Removed ScrollToTop after BrowserRouter
export default () => {
  return (
    <BrowserRouter>
      <Switch>
        <ScrollToTopRoute exact path="/" component={Home} />
        <ScrollToTopRoute exact path="/birth" component={Birth} />
        <ScrollToTopRoute exact path="/cities" component={Cities} />
        <ScrollToTopRoute exact path="/healthcare" component={Healthcare} />
        <ScrollToTopRoute exact path="/housing" component={Housing} />
        <ScrollToTopRoute exact path="/tax" component={Tax} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};



// WEBPACK FOOTER //
// ./src/routes.js